import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Grid } from "@mui/material";
import PosterSmall from "../components/PosterSmall";

import "./PersonInfoPage.css";

const config = require("../config.json");

export default function PersonInfoPage() {
  const { person_id } = useParams();
  const [personData, setPersonData] = useState({});

  useEffect(() => {
    fetch(
      `${
        process.env.NODE_ENV === "production"
          ? config.production_server_host
          : `${config.server_host}:${config.server_port}`
      }/person/${person_id}`
    )
      .then((res) => res.json())
      .then((resJson) => {
        setPersonData(resJson);
      });
  }, [person_id]);

return (
    <div className="person-info-page">
      <div className="nav-bar-holding-block"></div>

      <div style={{ color: "white" }}>
        {/* Person Info */}
        <Container>
          <div className="person-info-page-title">
            {personData.primary_name}
          </div>
          <div className="person-info-page-subtitle">
            {personData.birth_year && <span>{personData.birth_year}~</span>}
            {personData.death_year && <span>{personData.death_year}</span>}
          </div>
          <div className="person-info-page-profession">
          <b style={{ color: "#bbbbbb" }}>Primary Profession:</b> {personData.primary_profession}
          </div>
        </Container>

        {/* A List of the Person's Different Roles */}
        {personData.movies &&
          personData.movies.filter((movie) => movie.job_title === "director")
            .length > 0 && (
            <div>
              <Container>
                <h1 className="person-info-page-job-title">Director:</h1>
              </Container>
              <Container>
                <Grid container spacing={10}>
                  {personData.movies
                    .filter((movie) => movie.job_title === "director")
                    .map((movie) => ( 
                      <Grid item xs={6} md={3} key={movie.job_title+movie.imdb_id}>
                        <PosterSmall
                          imdb_id={movie.imdb_id}
                          title={movie.title}
                          poster_path={movie.poster_path}
                          rating={movie.vote_average}
                          year={movie.year}
                        ></PosterSmall>
                      </Grid>
                    ))}
                </Grid>
              </Container>
            </div>
          )}

          {personData.movies &&
          personData.movies.filter((movie) => movie.job_title === "composer")
            .length > 0 && (
            <div>
              <Container>
                <h1 className="person-info-page-job-title">Composer:</h1>
              </Container>
              <Container>
                <Grid container spacing={12}>
                  {personData.movies
                    .filter((movie) => movie.job_title === "composer")
                    .map((movie) => (
                      <Grid item xs={6} md={3} key={movie.job_title+movie.imdb_id}>
                        <PosterSmall
                          imdb_id={movie.imdb_id}
                          title={movie.title}
                          poster_path={movie.poster_path}
                          rating={movie.vote_average}
                          year={movie.year}
                        ></PosterSmall>
                      </Grid>
                    ))}
                </Grid>
              </Container>
            </div>
          )}

          {personData.movies &&
          personData.movies.filter((movie) => movie.job_title === "writer")
            .length > 0 && (
            <div>
              <Container>
                <h1 className="person-info-page-job-title">Writer:</h1>
              </Container>
              <Container>
                <Grid container spacing={12}>
                  {personData.movies
                    .filter((movie) => movie.job_title === "writer")
                    .map((movie) => (
                      <Grid item xs={6} md={3} key={movie.job_title+movie.imdb_id}>
                        <PosterSmall
                          imdb_id={movie.imdb_id}
                          title={movie.title}
                          poster_path={movie.poster_path}
                          rating={movie.vote_average}
                          year={movie.year}
                        ></PosterSmall>
                      </Grid>
                    ))}
                </Grid>
              </Container>
            </div>
          )}

          {personData.movies &&
          personData.movies.filter((movie) => movie.job_title === "producer")
            .length > 0 && (
            <div>
              <Container>
                <h1 className="person-info-page-job-title">Producer:</h1>
              </Container>
              <Container>
                <Grid container spacing={12}>
                  {personData.movies
                    .filter((movie) => movie.job_title === "producer")
                    .map((movie) => (
                      <Grid item xs={6} md={3}>
                        <PosterSmall
                          imdb_id={movie.imdb_id}
                          title={movie.title}
                          poster_path={movie.poster_path}
                          rating={movie.vote_average}
                          year={movie.year}
                        ></PosterSmall>
                      </Grid>
                    ))}
                </Grid>
              </Container>
            </div>
          )}

          {personData.movies &&
          personData.movies.filter((movie) => movie.job_title === "actor")
            .length > 0 && (
            <div>
              <Container>
                <h1 className="person-info-page-job-title">Actor:</h1>
              </Container>
              <Container>
                <Grid container spacing={12}>
                  {personData.movies
                    .filter((movie) => movie.job_title === "actor")
                    .map((movie) => (
                      <Grid item xs={6} md={3}>
                        <PosterSmall
                          imdb_id={movie.imdb_id}
                          title={movie.title}
                          poster_path={movie.poster_path}
                          rating={movie.vote_average}
                          year={movie.year}
                        ></PosterSmall>
                      </Grid>
                    ))}
                </Grid>
              </Container>
            </div>
          )}
      </div>
    </div>
  );
}
